'use client'

import { useEffect, useRef } from 'react'
import Cookies from 'js-cookie'
import { cognitoLogout } from '@/lib/auth'

const IDLE_TIMEOUT_MS = 60 * 60 * 1000
const ACTIVITY_EVENTS: Array<keyof WindowEventMap> = [
  'click',
  'keydown',
  'touchstart',
  'pointerdown',
  'wheel',
  'scroll',
  'input',
]

function logout() {
  Cookies.remove('access_token')
  Cookies.remove('refresh_token')
  Cookies.remove('user_role')
  Cookies.remove('user_name')
  cognitoLogout()
}

export default function SessionTimeout() {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const resetTimeout = () => {
      if (!Cookies.get('access_token')) return

      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        if (Cookies.get('access_token')) logout()
      }, IDLE_TIMEOUT_MS)
    }

    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, resetTimeout, { capture: event === 'scroll' })
    })
    resetTimeout()

    return () => {
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, resetTimeout, { capture: event === 'scroll' })
      })
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return null
}